import { gql } from '@apollo/client';

export const loggedUserData = gql`
  fragment LoggedUserData on User {
    _id
    personalData {
      avatar
      proxiAvatar
      email
      firstName
      lastName
      dob
      pronouns
      zipCode
      location
      language
      occupation
      yearOfBirth
      placeOfBirth
      bio
      phone
      preferredInterviewChannel
      smsConsent {
        granted
        status
      }
    }
    serviceData {
      introFinished
      onboardingFinished
      preTrainFinished
      contributorOnboardingFinished
      voiceId
    }
  }
`;

export const invitationDocumentData = gql`
  fragment InvitationDocumentData on InvitationDocument {
    id
    name
    description
    type
  }
`;

export const invitationDetailsData = gql`
  fragment InvitationDetailsData on InvitationDetails {
    email
    type
    docId
    inviterName
    inviterAvatar
    circleName
    seriesName
    fullName
    expiresAt
    categoryId
    expectedUserId
    skipAuth
    leadCaptureMode
    isArchive
    game
    mediaRequests {
      key
      label
      type
      required
      maxCount
      description
    }
  }
`;

export const invitationMetadataData = gql`
  fragment InvitationMetadataData on InvitationMetadata {
    circleName
    inviterName
    fullName
    phoneNumber
    role
    message
    inviteToCircle
    userId
    categoryId
    interviewId
  }
`;

export const invitationData = gql`
  fragment InvitationData on Invitation {
    _id
    type
    email
    circleId
    proxiCastId
    docId
    inviterId
    token
    status
    invitedAt
    acceptedAt
    expiresAt
    createdAt
    updatedAt
    metadata {
      ...InvitationMetadataData
    }
    document {
      ...InvitationDocumentData
    }
  }
  ${invitationMetadataData}
  ${invitationDocumentData}
`;
